module.exports = __webpack_public_path__ + "img/product-manager.4f3399c6.svg";